import styled from 'styled-components';
import { Overlay } from 'ui/overlay';

const StyledOverlay = styled(Overlay)`
  background-color: color-mix(in srgb, #18041c 12%, transparent);
`;

export const TakeoverOverlay = () => {
  return <StyledOverlay preventBodyScroll zIndex={-1} />;
};
